import { UseFormReturn } from "react-hook-form";
import { useMemo } from "react";
import { FormRadioGroupInput } from "./masked_inputs/react_forms/form_radio_group_input";

/**
 * DefaultFormNewSwitch
 */

type Props<T extends {}> = {
  name: keyof T;
  label?: string;
  required?: boolean;
  showCleanButton?: boolean;
  readOnly?: boolean;
  arrangement?: 'horizontal' | 'vertical';
  reactHookForm: UseFormReturn<T>;
  onValueChange?: (value: number | null, prevValue: number | null) => void;
};

export const DefaultFormNewSwitch = <T extends {},>({
  name,
  label,
  required,
  showCleanButton,
  readOnly,
  arrangement,
  reactHookForm,
  onValueChange,
}: Props<T>) => {

  const statusOptions = useMemo(() => {
    return [
      {
        id: 1,
        label: 'Sim',
        style: {
          backgroundColor: '#45b6af',
          color: 'white',
          padding: '.2rem .4rem',
          fontSize: '0.85rem',
          fontWeight: 700,
          textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000',
          borderRadius: '2px',
        },
      },
      {
        id: 0,
        label: 'Não',
        style: {
          backgroundColor: '#f3565d',
          color: 'white',
          padding: '.2rem .4rem',
          fontSize: '0.85rem',
          fontWeight: 700,
          textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000',
          borderRadius: '2px',
        },
      },
    ];
  }, [
  ]);

  return (
    <FormRadioGroupInput
      name={name as any}
      label={label}
      options={statusOptions}
      required={required}
      showCleanButton={showCleanButton}
      arrangement={arrangement}
      readOnly={readOnly}
      reactHookForm={reactHookForm}
      onValueChange={onValueChange}
    />
  );
}